import { indexRoute } from '@/app/routing/root/auth/index/route';
import { signUpRoute } from '@/app/routing/root/auth/sign-up/route';

export const authRoute = {
  path: 'auth',
  children: [
    indexRoute,
    signUpRoute,
  ],
}